export default {
    ComponentStyleConfig: {
      editorDOM: {
        margin: true,
        padding: true,
        showTxt: "外边框"
      },
      container: {
        size: {
          width: true
        },
        showTxt: "内容区"
      }
    },
  };
  